var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"loading-fade"},on:{"after-leave":_vm.handleAfterLeave}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],class:['loading-mask', {
      fullscreen: _vm.fullscreen
    }]},[_c('div',{class:['loading-spinner', {
        light: _vm.light
      }]},[_c('div',{staticClass:"icon-loading-container"},[_c('IconLoading')],1),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"loading-text"},[_vm._v("\n        "+_vm._s(_vm.text)+"\n      ")]):_vm._e()])])])}
var staticRenderFns = []

export { render, staticRenderFns }